import React, { useMemo } from 'react';

import { MarkdownPreview, styled, useParams, useSelector } from 'third-party';

import { termsAndConditionsSelectors } from 'selectors';

import { docsComponents } from 'features/Docs/Components';

const StyledMarkdownPreview = styled(MarkdownPreview)`
  background-color: ${props => props.theme.custom.palette.backgroundTheme};
`;

export const TermsAndConditionsPreview: React.FC = () => {
  const { documentId } = useParams();

  const termsAndConditionsItemsTree = useSelector(
    termsAndConditionsSelectors.termsAndConditionsItemsTree,
  );

  const selectedTermsAndConditions = useMemo(
    () => termsAndConditionsItemsTree?.find(item => item.id === documentId),
    [documentId, termsAndConditionsItemsTree],
  );

  return (
    <StyledMarkdownPreview
      source={selectedTermsAndConditions?.document.text || ''}
      components={docsComponents as any}
      disableCopy
    />
  );
};
